/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HideForFuture/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxReadOnly from 'DesignSystem/TysiaCheckboxReadOnly/index'
import TysiaListColumn from 'DesignSystem/TysiaList/TysiaListColumn/index'



/** @type {import('Simple/types.js').View} */
export default function HideForFuture({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList/Item/HideForFuture"
  
}) {
let txCardFieldDefinitionHideForFutureValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'hide_for_future',
})
  return (<React.Fragment
>
<TysiaListColumn
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaCheckboxReadOnly
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxReadOnly`}
 data="tx_card_field_definition.hide_for_future"
 value={txCardFieldDefinitionHideForFutureValueData}
/>
)}
</TysiaListColumn>
{children}
</React.Fragment>)
}